var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category mr-3 float-left",class:{selected: _vm.selected},on:{"click":_vm.select}},[(_vm.id)?_c('span',{staticClass:"category-code"},[_vm._v("\n    SE"+_vm._s(_vm.id)+"\n  ")]):_vm._e(),_vm._v(" "),_c('small',{staticClass:"category-name"},[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa09427c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Dashboard/Statistics/Prices/Category.vue
// module id = 472
// module chunks = 0